<button
    mat-raised-button
    color="primary"
    class="!rounded-lg"
    (click)="handleAddCreditCardClick()"
>
    Add Payment Card
</button>

<div class="mt-4 max-h-[400px] overflow-y-auto flex flex-col gap-3 pr-2">
    @for (card of cardsOnFile; track card.id) {
        <app-card-on-file
            [card]="card"
            [cardsOnFile]="cardsOnFile"
            (refreshCardsOnFile)="loadCreditCards()"
        />
    }
</div>
